export function taxTermsHome() {
    (function($) {
        //Function for Ajax Load More Listing items
        //new AjaxLoadMore();

        $('.tabs_block button').click(function(e) {
            //e.preventDefault(); // Previeni il comportamento predefinito del link
    
            let taxSlug = $(this).data('taxonomy-slug');
        
            // Esegui la richiesta AJAX
            $.ajax({
                url: ajax_object.ajax_url, // La variabile ajax_url è fornita da WordPress
                type: 'post',
                data: {
                    action: 'load_taxonomy_block_items',
                    tax_slug: taxSlug,
                },
                success: function(response) {
                    // Inserisci il contenuto della risposta nel tuo container desiderato
                    $('#tab_taxt_terms').html(response);
                    $('#terms_home_carousel').owlCarousel({
                        loop:false,
                        items:1,
                        margin:20,
                        dots:true,
                        nav:false,
                    })
                },
                error: function(error) {
                    console.log(error);
                }
            });
        });

    })(jQuery);
}